import { useQuery } from '@apollo/client';
import { SliderCard } from '@bnnvara/cards';
import { Article as ArticleIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Article';
import { Chevron } from '@bnnvara/icons/src/components/UserInterfaceIcons/Chevron';
import { Play } from '@bnnvara/icons/src/components/UserInterfaceIcons/Play';
import Slider from '@bnnvara/slider';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { RANDOM_RECOMMENDATION_QUERY } from '../../api/queries/recommendation.gql';
import resizeImageSource from '../../helpers/resizeImageSource';
import Link from '../Link';
import * as S from './styled';

const Brandnavigation = ({ isBrand }) => {
  const prevArrow = (
    <S.PrevArrow>
      <Chevron />
    </S.PrevArrow>
  );

  const nextArrow = (
    <S.NextArrow>
      <Chevron />
    </S.NextArrow>
  );

  const [isClient, setClientState] = useState(false);

  // this is needed because of this issue in react-slick: https://github.com/akiran/react-slick/issues/1245
  useEffect(() => {
    setClientState(true);
  }, [setClientState]);

  const sliderSettings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    initialSlide: 0,
    lazyLoad: true,
    autoplay: true,
    autoplaySpeed: 4000,
  };
  const responsive = [
    {
      breakpoint: 320,
      settings: {
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ];

  // fetch 50 items, filter in resolver to randomize result to max 16 items
  const { loading, error, data } = useQuery(RANDOM_RECOMMENDATION_QUERY, {
    variables: {
      limit: 50,
    },
  });

  if (!data || loading || error) return null;

  const { edges } = data.randomRecommendation;
  const createUrl = (brand, type, slug) => {
    if (type === 'Article' && brand.slug !== 'Portal') {
      return `${brand}/artikelen/${slug}`;
    }
    return `/artikelen/${slug}`;
  };

  if (edges && edges.length > 3) {
    return (
      <S.BrandNavigationSlider>
        <S.SliderTitle>Ontdek BNNVARA</S.SliderTitle>
        <Slider
          isBrand={isBrand}
          key={isClient ? 'client' : 'server'}
          responsive={isClient ? responsive : null}
          speed={500}
          prevArrow={prevArrow}
          nextArrow={nextArrow}
          className="brand-navigation"
          {...sliderSettings}
        >
          {edges.map((item, index) => (
            <Link
              // eslint-disable-next-line no-underscore-dangle
              href={createUrl(item.brand.slug, item.__typename, item.slug)}
              // eslint-disable-next-line no-underscore-dangle
              link={createUrl(item.brand.slug, item.__typename, item.slug)}
              key={item.id}
              category="brandSlider"
              action="click"
              label={`slide-${index}`}
            >
              <SliderCard
                key={item.id}
                thumbnail={
                  item.thumbnail
                    ? resizeImageSource(item.thumbnail.url, 300, 16 / 9)
                    : 'data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAfQAAAABCAQAAACC95QfAAAAEUlEQVR42mNkGAWjYBQMewAAB9IAAi/SD5wAAAAASUVORK5CYII='
                }
                icon={
                  // eslint-disable-next-line no-underscore-dangle
                  item.__typename === 'Article' ? <ArticleIcon /> : <Play />
                }
                title={item.title}
                brandName={item.brand.name}
              />
            </Link>
          ))}
        </Slider>
      </S.BrandNavigationSlider>
    );
  }
  return null;
};

Brandnavigation.propTypes = {
  isBrand: PropTypes.bool,
};

Brandnavigation.defaultProps = {
  isBrand: true,
};

export default Brandnavigation;
